import { jsxs as t, jsx as e, Fragment as n } from "react/jsx-runtime";
import { CloseIcon as c } from "@systemeio/ui/icons";
import { useTranslation as h } from "../../i18n.mjs";
import { twMerge as d } from "tailwind-merge";
import { FilePreview as p } from "../file-preview/index.mjs";
import { formatBytes as b } from "../../utils/format-bytes.mjs";
function H({
  fileType: o,
  src: u,
  alt: f,
  name: l,
  size: r,
  className: i,
  onClose: a,
  showCloseButton: s = !0,
  isFetching: x
}) {
  const { t: m } = h();
  return x ? /* @__PURE__ */ t("div", { className: d("flex w-full flex-col items-end", i), children: [
    s && /* @__PURE__ */ e("button", { type: "button", onClick: a, className: "mb-5", children: /* @__PURE__ */ e(c, { width: 17, height: 17, className: "fill-text-primary cursor-pointer" }) }),
    /* @__PURE__ */ t("div", { className: "flex w-full flex-col", children: [
      /* @__PURE__ */ e("div", { className: "bg-background-tertiary h-[300px] w-full animate-pulse rounded-md" }),
      /* @__PURE__ */ e("div", { className: "bg-background-tertiary mt-5 h-4 w-16 animate-pulse rounded-sm" }),
      /* @__PURE__ */ e("div", { className: "bg-background-tertiary mt-2 h-6 w-full animate-pulse rounded-sm" }),
      /* @__PURE__ */ e("div", { className: "bg-background-tertiary mt-2 h-4 w-16 animate-pulse rounded-sm" }),
      /* @__PURE__ */ e("div", { className: "bg-background-tertiary mt-2 h-6 w-full animate-pulse rounded-sm" })
    ] })
  ] }) : /* @__PURE__ */ t("div", { className: d("flex w-full flex-col items-end", i), children: [
    s && /* @__PURE__ */ e("button", { type: "button", onClick: a, className: "mb-5", children: /* @__PURE__ */ e(c, { width: 17, height: 17, className: "fill-text-primary cursor-pointer" }) }),
    /* @__PURE__ */ t("div", { className: "flex w-full flex-col", children: [
      /* @__PURE__ */ e(p, { src: u ?? "", fileType: o, alt: f }),
      l && /* @__PURE__ */ t(n, { children: [
        /* @__PURE__ */ e(
          "div",
          {
            className: "text-text-secondary mt-5 overflow-clip truncate text-sm",
            style: { lineHeight: 1.1 },
            children: m("file_manager.name")
          }
        ),
        /* @__PURE__ */ e(
          "div",
          {
            className: "text-text-tertiary mt-2 truncate text-base font-semibold ",
            title: l,
            style: { lineHeight: 1.1 },
            children: l
          }
        )
      ] }),
      typeof r == "number" && /* @__PURE__ */ t(n, { children: [
        /* @__PURE__ */ e(
          "div",
          {
            className: "text-text-secondary mt-[10px] overflow-clip truncate text-sm",
            style: { lineHeight: 1.1 },
            children: m("file_manager.size")
          }
        ),
        /* @__PURE__ */ e(
          "div",
          {
            className: "text-text-tertiary mt-2 text-base font-semibold",
            style: { lineHeight: 1.1 },
            children: b(r)
          }
        )
      ] })
    ] })
  ] });
}
export {
  H as FileDetails
};
